var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircleContainedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99978 1.40015C3.90699 1.40015 1.39978 3.90735 1.39978 7.00015C1.39978 10.0929 3.90698 12.6001 6.99978 12.6001C10.0926 12.6001 12.5998 10.0929 12.5998 7.00015C12.5998 3.90735 10.0926 1.40015 6.99978 1.40015ZM6.39978 10.0335C6.39978 10.3649 6.66841 10.6335 6.99978 10.6335C7.33115 10.6335 7.59978 10.3649 7.59978 10.0335C7.59978 9.70216 7.33115 9.43353 6.99978 9.43353C6.66841 9.43353 6.39978 9.70216 6.39978 10.0335ZM6.09978 5.95015C6.09978 5.45309 6.50272 5.05015 6.99978 5.05015C7.49684 5.05015 7.89978 5.45309 7.89978 5.95015C7.89978 6.4472 7.49684 6.85015 6.99978 6.85015C6.66841 6.85015 6.39978 7.11878 6.39978 7.45015V8.23355C6.39978 8.56492 6.66841 8.83355 6.99978 8.83355C7.33115 8.83355 7.59978 8.56492 7.59978 8.23355V7.96319C8.46723 7.70502 9.09978 6.90146 9.09978 5.95015C9.09978 4.79035 8.15958 3.85015 6.99978 3.85015C5.83998 3.85015 4.89978 4.79035 4.89978 5.95015C4.89978 6.28152 5.16841 6.55015 5.49978 6.55015C5.83115 6.55015 6.09978 6.28152 6.09978 5.95015Z",
    fill: "#7F7D83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleContainedFilled);
export default __webpack_public_path__ + "static/media/help-circle-contained-filled.424cb273904f6f0bade265c16da7813a.svg";
export { ForwardRef as ReactComponent };